import { createContext, useContext } from 'react';

// A document the composer can pin as a removable chip above the textarea. The
// id drives the `:documentation{id=…}` reference appended on send; the name is
// shown on the chip.
export type AiChatDocRef = { id: string; name: string };

// Lets a deeply-nested inline doc chip (DocReference → MessageMarkdown) attach a
// document reference to the chat composer without threading a callback through
// every markdown renderer. ConversationPane provides the real handler (wired to
// ChatInput's imperative attach); the default is a no-op so chips rendered
// outside a conversation (tests, storybook) stay inert.
export type AiChatInsert = (doc: AiChatDocRef) => void;

const AiChatInsertContext = createContext<AiChatInsert>(() => undefined);

export function useAiChatInsert(): AiChatInsert {
  return useContext(AiChatInsertContext);
}

export default AiChatInsertContext;
